import React from 'react';
import { createPortal } from 'react-dom';
import pt from 'prop-types';

import Icon from 'components/icon';
import Button from 'components/button';

import { postStorefrontOverlayPageEllipsis } from 'components/storefront/editor/utils/post-message';

const SIDEBAR_ROOT_ID = 'sidebar-panels-root';

export default class EasyblocksPageActions extends React.PureComponent {
  static propTypes = {
    page: pt.object,
    loading: pt.bool,
  };

  /** @param {React.MouseEvent<HTMLButtonElement>} event */
  onClickPageActions = (event) => {
    const { page } = this.props;
    const domRect = event.target.getBoundingClientRect();

    postStorefrontOverlayPageEllipsis(domRect, page);
  };

  shouldRenderActionsButton() {
    const { page } = this.props;

    if (!page) {
      return false;
    }

    return page.custom || page.id === 'index';
  }

  render() {
    const { page, loading } = this.props;
    const sidebarContainer = document.getElementById(SIDEBAR_ROOT_ID);

    if (!sidebarContainer) {
      return null;
    }

    return createPortal(
      <div className="storefront-editor--easyblocks--page-header">
        <span className="storefront-editor--easyblocks--page-label">
          {page.label}
        </span>
        {this.shouldRenderActionsButton() && (
          <Button
            className="storefront-editor--easyblocks--page-actions"
            onClick={this.onClickPageActions}
            disabled={loading}
          >
            <Icon fa="ellipsis-h" />
          </Button>
        )}
      </div>,
      sidebarContainer,
    );
  }
}
